import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '@/store'
import { getToken, removeToken } from '@/utils/auth' // 新增 removeToken 导入
import errorCode from '@/utils/errorCode'
import { currentDomain } from '@/utils/domain'

// 'http://192.168.0.21:18080' ||
// 'http://www.leboparkingtest.com/prod-api'
// 创建axios实例
const service = axios.create({
  baseURL:  currentDomain.api, 
  timeout: 30000, 
  headers: { 'Content-Type': 'application/json;charset=utf-8' }
})

// 是否显示重新登录弹窗（防止重复弹窗）
let isRelogin = { show: false }

// 请求拦截器：添加Token
service.interceptors.request.use(
  config => {
    // 携带Token（排除不需要Token的请求）
    if (getToken() && !config.headers.isToken) {
      config.headers['Authorization'] = 'Bearer ' + getToken()
    }
    // GET 参数过滤空值（与若依 tansParams 行为一致，空字符串/undefined 不传给后端）
    if (config.method === 'get' && config.params) {
      Object.keys(config.params).forEach(key => {
        const value = config.params[key]
        if (value === null || value === undefined || value === '') {
          delete config.params[key]
        }
      })
    }
    return config
  },
  error => {
    console.error('请求拦截器错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器：处理返回结果和错误
service.interceptors.response.use(res => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200
    // 获取错误信息
    const msg = errorCode[code] || res.data.msg || errorCode['default']
    // 二进制数据则直接返回
    if (res.request.responseType ===  'blob' || res.request.responseType ===  'arraybuffer') {
      return res.data
    }
    if (code === 401) {
      if (!isRelogin.show) {
        isRelogin.show = false
        store.dispatch('LogOut').then(() => {
          location.href = '/index'
        })
        // MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', { confirmButtonText: '重新登录', cancelButtonText: '取消', type: 'warning' }).then(() => {
        //   isRelogin.show = false
        //   store.dispatch('LogOut').then(() => {
        //     location.href = '/index'
        //   })
        // }).catch(() => {
        //   isRelogin.show = false
        // })
    }
      return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
    } else if (code === 500) {
      Message({ message: msg, type: 'error' })
      return Promise.reject(new Error(msg))
    } else if (code === 601) {
      Message({ message: msg, type: 'warning' })
      return Promise.reject('error')
    } else if (code !== 200) {
      Notification.error({ title: msg })
      return Promise.reject('error')
    } else {
      return res.data
    }
  },
  error => {
    console.log('err' + error)
    let { message } = error
    if (message == "Network Error") {
      message = "后端接口连接异常"
    } else if (message.includes("timeout")) {
      message = "系统接口请求超时"
    } else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常"
    }
    Message({ message: message, type: 'error', duration: 5 * 1000 })
    return Promise.reject(error)
  }
)

export default service